import type { TranslationKey } from '../i18n';
import type { ProductType, Stage } from '../types/api';

/** Canonical stage label keys — default (report / industrial) wording. */
export const STAGE_LABEL_KEY: Record<Stage, TranslationKey> = {
  VALIDATION: 'stage.validation',
  VERIFICATION: 'stage.verification',
  PRIORITIZATION: 'stage.prioritization',
  REALIZATION: 'stage.realization',
  INTEGRATOR_SELECTION: 'stage.integratorSelection',
  TKP: 'stage.tkp',
  CONTRACT: 'stage.contract',
};

/**
 * Display stage label by (stage, product type) — single source for the Leads
 * board and the Dashboard funnel (#74). The educational route renames two
 * steps in the customer's wording: the concept step already covers the
 * proposal («Концепт проекта / ТКП») and the proposal step is effectively the
 * contract («Контракт»). Display-level only: filters, reports, timelines and
 * statuses keep the canonical stage names.
 */
export function stageLabelKey(
  stage: Stage,
  productType?: ProductType | null,
): TranslationKey {
  if (productType === 'EDUCATIONAL_ROBOT') {
    if (stage === 'REALIZATION') return 'stage.realizationEducational';
    if (stage === 'TKP') return 'stage.tkpEducational';
  }
  return STAGE_LABEL_KEY[stage];
}
